import React from 'react'
import GlobalProvider from './Contexts/GlobalProvider'
import { openWidget, closeWidget, toggleWidget, toggleDisplay } from './Contexts/InputOutputHandler'
import type { RetorikMainComponentProps, RetorikWidgetProps } from '../models/retorikTypes'
import ShadowRoot from './Common/ShadowRoot'
import LayoutHandler from './Common/LayoutHandler'
import { ContainerParent } from '../models/enums'
import RetorikConfigHandler from './Common/RetorikConfigHandler'

window.Retorik = {
  ...window.Retorik,
  openWidget,
  closeWidget,
  toggleWidget,
  toggleDisplay
}

const RetorikWidget = (props: RetorikMainComponentProps & RetorikWidgetProps): JSX.Element => {
  // --------- /!\ -----------
  // Ne mettre ici que de la logique spécifique au widget
  // Ce qui est commun avec RetorikAgent ou autres doit aller dans RetorikComposer ou ContextProvider
  // -------------------------

  return (
    <GlobalProvider instanceId={props.instanceId}>
      <ShadowRoot>
        <LayoutHandler {...props}>
          <RetorikConfigHandler
            {...{
              ...props,
              width: 'full',
              height: 'full',
              parent: ContainerParent.widget
            }}
          />
        </LayoutHandler>
      </ShadowRoot>
    </GlobalProvider>
  )
}

export default RetorikWidget
